var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('span',{staticClass:"word"},[_vm._v(_vm._s(_vm.item.text))]),_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm._f("separateNumber")(_vm._f("roundFloatingPointNumber")(_vm.item.frequency,2))))]),_c('div',{staticClass:"line"},[_c('div',{staticClass:"p-contentplans-graph__bar",style:({ height: '10px', width: _vm.barW + '%' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }